// Web implementation — renders children into `document.body` via
// `react-dom/createPortal` so floating popovers (mention,
// emoji, link-edit) escape the composer's stacking / overflow
// contexts and anchor cleanly to viewport-coordinate rects.
//
// The native sibling (`WebPortal.native.tsx`) is a passthrough;
// metro / vite pick the right file via platform extensions.

import React from 'react';
import { createPortal } from 'react-dom';

interface WebPortalProps {
  readonly children: React.ReactNode;
}

export function WebPortal({ children }: WebPortalProps): React.ReactPortal | null {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
